module.exports = __webpack_public_path__ + "img/微信.8a758edf.svg";